import React from "react";
import { render } from "react-dom";
import { setCellBackground, getStateGoalPercentage } from "../../util/utils";
import { Translation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default class ThisQuarterInMyTeamDashboard extends React.Component{

    render() {

        const {
          thisQuarterInMyTeam,
          myYear
        } = this.props;
        let brandGoals = {},
          brandSales = {};
        let totalBrandGoal = 0,
          totalBrandSale = 0;
        return (
            <Translation ns="translation">
            {(t, { i18n }) => {
                return (
                  <div className="col-md-12 m-b-30">
                    <div className="card">
                      <div className="card-header py-3">
                        <h4 className="h6 m-0">
                          {t("dashBoard.thisQuarterInMyTeam")}
                        </h4>
                      </div>
                      <div id="collapse-collapsed3" class="collapse collapse-panel" aria-labelledby="heading-collapsed">
                      <div className="card-body pb-0">
                        <div className="table-responsive table-scroll">
                          <table className="table table-bordered small-table m-0">
                            <thead className="bg-light">
                              <tr>
                                <th>{t("dashBoard.team")}</th>

                                {myYear &&
                                  myYear.map((item, index) => {
                                    brandGoals = {
                                      ...brandGoals,
                                      [item.name]: 0,
                                    };
                                    brandSales = {
                                      ...brandSales,
                                      [item.name]: 0,
                                    };
                                    return (
                                      <th
                                        key={index}
                                        colspan="3"
                                        className="text-center thick-border"
                                      >
                                        {item.name && item.name}
                                      </th>
                                    );
                                  })}

                                <th
                                  colspan="3"
                                  className="text-center thick-border font-weight-bold"
                                >
                                  {t("timeStatistic.sum")}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td></td>
                                {myYear &&
                                  myYear.map((item, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <td className="text-center">
                                          {t("teamStatistic.ziel")}{" "}
                                        </td>
                                        <td className="text-center">
                                          {t("teamStatistic.lst")}
                                        </td>
                                        <td className="text-center thick-border">
                                          {t("teamStatistic.in")}
                                        </td>
                                      </React.Fragment>
                                    );
                                  })}
                                <td className="text-center font-weight-bold">
                                  {t("teamStatistic.ziel")}{" "}
                                </td>
                                <td className="text-center font-weight-bold">
                                  {t("teamStatistic.lst")}
                                </td>
                                <td className="text-center thick-border font-weight-bold">
                                  {t("teamStatistic.in")}
                                </td>
                              </tr>
                              {thisQuarterInMyTeam &&
                                thisQuarterInMyTeam.map(
                                  (item, index) => {
                                    let brandList = item.brand_list.sort((a, b) =>
                                      a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
                                    );
                                    let quarterlyGoalSum = 0,
                                      quarterySaleSum = 0;
                                    return (
                                      <tr key={index}>
                                        <td>{item.name}</td>
                                        {brandList &&
                                          brandList.map(
                                            (brand, brandIndex) => {
                                              if(brand.name!=='GW Ankauf'){
                                                quarterlyGoalSum +=
                                                  parseInt(
                                                    brand.goal
                                                  );
                                                quarterySaleSum +=
                                                  parseInt(
                                                    brand.sale
                                                  );
                                              }
                                              brandGoals[
                                                brand.name
                                              ] += parseInt(
                                                brand.goal
                                              );
                                              brandSales[
                                                brand.name
                                              ] += parseInt(
                                                brand.sale
                                              );
                                              return (
                                                <React.Fragment
                                                  key={brandIndex}
                                                >
                                                  <td
                                                    className={`text-center ${setCellBackground(
                                                      brand.sale,
                                                      brand.goal
                                                    )}`}
                                                  >
                                                    {brand.goal}
                                                  </td>
                                                  <td
                                                    className={`text-center ${setCellBackground(
                                                      brand.sale,
                                                      brand.goal
                                                    )}`}
                                                  >
                                                    {brand.sale}
                                                  </td>
                                                  <td
                                                    className={`text-center thick-border ${setCellBackground(
                                                      brand.sale,
                                                      brand.goal
                                                    )}`}
                                                  >
                                                    {`${getStateGoalPercentage(
                                                      brand.sale,
                                                      brand.goal
                                                    )}%`}
                                                  </td>
                                                </React.Fragment>
                                              );
                                            }
                                          )}
                                        <td
                                          className={`${setCellBackground(
                                            quarterySaleSum,
                                            quarterlyGoalSum
                                          )} text-center font-weight-bold`}
                                        >
                                          {quarterlyGoalSum}
                                        </td>
                                        <td
                                          className={`${setCellBackground(
                                            quarterySaleSum,
                                            quarterlyGoalSum
                                          )} text-center font-weight-bold`}
                                        >
                                          {quarterySaleSum}
                                        </td>
                                        <td
                                          className={`${setCellBackground(
                                            quarterySaleSum,
                                            quarterlyGoalSum
                                          )} text-center thick-border font-weight-bold`}
                                        >
                                          {`${getStateGoalPercentage(
                                            quarterySaleSum,
                                            quarterlyGoalSum
                                          )}%`}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              <tr>
                                <td className="font-weight-bold">
                                  {t("timeStatistic.sum")}
                                </td>
                                {myYear &&
                                  myYear.map((brand, index) => {
                                    totalBrandGoal +=
                                      brandGoals[brand.name];
                                    totalBrandSale +=
                                      brandSales[brand.name];
                                    return (
                                      <React.Fragment key={index}>
                                        <td
                                          className={`${setCellBackground(
                                            brandSales[brand.name],
                                            brandGoals[brand.name]
                                          )} text-center font-weight-bold`}
                                        >
                                          {brandGoals[brand.name]}
                                        </td>
                                        <td
                                          className={`${setCellBackground(
                                            brandSales[brand.name],
                                            brandGoals[brand.name]
                                          )} text-center font-weight-bold`}
                                        >
                                          {brandSales[brand.name]}
                                        </td>
                                        <td
                                          className={`${setCellBackground(
                                            brandSales[brand.name],
                                            brandGoals[brand.name]
                                          )} text-center thick-border font-weight-bold`}
                                        >
                                          {`${getStateGoalPercentage(
                                            brandSales[brand.name],
                                            brandGoals[brand.name]
                                          )}%`}
                                        </td>
                                      </React.Fragment>
                                    );
                                  })}
                                <td
                                  className={`${setCellBackground(
                                    totalBrandSale,
                                    totalBrandGoal
                                  )} text-center font-weight-bold`}
                                >
                                  {totalBrandGoal}
                                </td>
                                <td
                                  className={`${setCellBackground(
                                    totalBrandSale,
                                    totalBrandGoal
                                  )} text-center font-weight-bold`}
                                >
                                  {totalBrandSale}
                                </td>
                                <td
                                  className={`${setCellBackground(
                                    totalBrandSale,
                                    totalBrandGoal
                                  )} text-center thick-border font-weight-bold`}
                                >
                                  {`${getStateGoalPercentage(
                                    totalBrandSale,
                                    totalBrandGoal
                                  )}%`}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      </div>
                      <div className="card-footer border-0">
                        <div className="text-right">
                      <Link
                          to="/statistics/team"
                          className="font-weight-600"
                        >
                          {t("dashBoard.moreDetails")}
                        </Link>
                        </div>
                        <div className="tet-left">
                        <a class="collapsed d-block" data-toggle="collapse" href="#collapse-collapsed3" aria-expanded="true" aria-controls="collapse-collapsed" id="heading-collapsed"><i class="fa fa-chevron-up pull-right"></i></a>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            }}
            </Translation>
        )
    }
}
